<ng-content></ng-content>


// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/navigation/sidenav/sidenav-info/sidenav-info.component.ts.CuiSidenavInfoComponent.html